import React from 'react'
import {connect} from 'react-redux'
import qs from 'qs';
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../comum/Titulo';
import {PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa, hasPerfil} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import ModalCadastrarConfiguracaoBilhete from './ModalCadastrarConfiguracaoBilhete';
import ConfiguracaoBilhete from './ConfiguracaoBilhete';
import buscarEmpresa from '../../actions/empresa/buscarEmpresas';
import {buscarConfiguracoesBilhete} from '../../actions/configuracao-bilhete/configuracaoBilheteActions';
import buscarRegraCalculoBilhete from '../../actions/configuracao-bilhete/buscaRegraCalculoBilheteAction';
import {selecionarBilhete} from '../../actions/configuracao-bilhete/selecionarBilhete';
import buscarOpcoesFiltrosConfiguracaoBilhete from '../../actions/configuracao-bilhete/buscarOpcoesFiltrosConfiguracaoBilhete';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';

export const CabecalhoTabela = () => (
  <div className="vx-gp-table-header vx-gp-table-header--bilhete d-none d-lg-grid">
    <div></div>
    <div>Cidade</div>
    <div>Regra</div>
  </div>
);


export class PainelConfiguracaoBilhete extends React.Component {
  constructor (props) {
    super(props);
    this.selecionarEmpresa = this.selecionarEmpresa.bind(this);

    this.state = {
      textoFiltro: null,
      arquivo: null,
      codigoEmpresaSelecionada: null,
      pagina: null,
    };
  }

  componentDidMount(){
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
      if (parametros.codigoEmpresa) {
        this.setState({
              codigoEmpresaSelecionada: parametros.codigoEmpresa,
              pagina: parametros.pagina ? parametros.pagina : 'gestao'
            }
        )        
        this.props.buscarConfiguracoesBilhete(parametros.codigoEmpresa);
        this.props.buscarOpcoesFiltrosConfiguracaoBilhete();
      }      
  }

  componentDidUpdate(prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.setState({
        codigoEmpresaSelecionada: this.props.empresaSelecionada.id,
      })
      window.location.href = window.location.href.replace(window.location.search, '?codigoEmpresa='+this.props.empresaSelecionada.id)      
    }
  }


  // eslint-disable-next-line class-methods-use-this
  exibirBotaoNovaConfiguracao () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
        <div className="vx-gp-toolbar">
          <button data-toggle="modal"
                  data-target="#modalCadastrarConfiguracaoBilhete"
                  className="vx-btn-primary">
            <i className="material-icons">add</i>
            Nova Configuração
          </button>
        </div>
      </Autorizacao>)
  }

  selecionarEmpresa (empresa) {
    this.setState({ empresaSelecionada: empresa });
  }


  exibirTabelaEmpresas () {
    if (this.props.configuracaoBilhete && this.props.configuracaoBilhete.length) {
      return (
        <div>
          <CabecalhoTabela/>
          <div>{this.exibirEmpresas()}</div>
        </div>
      );
    }
    return (
      <div className="vx-gp-empty">
        <span className="material-icons vx-gp-empty-icon">confirmation_number</span>
        <p className="vx-gp-empty-text">Nenhuma configuração de bilhete cadastrada.</p>
      </div>
    );
  }

  buscarConfiguracoesBilhete(){
      this.props.buscarConfiguracoesBilhete(this.state.codigoEmpresaSelecionada)
  }

  exibirEmpresas () {
    if(this.props.configuracaoBilhete && this.props.configuracaoBilhete.length){
      return this.props.configuracaoBilhete
      .map((configuracao, index) => <ConfiguracaoBilhete key={`configuracao-bilhete-${index}`} configuracao={configuracao}
                                                    idEmpresa={this.state.codigoEmpresaSelecionada}
                                                    indice={index}
                                                    selecionarBilhete={this.props.selecionarBilhete} />)
    }
  }

  getRetornoPainel() {
    if (hasPerfil(PERFIL_ADMIN)) {      
      if (this.state.pagina == 'empresa') {
        return '/painel-empresas';  
      } else {
        return '/gestao-empresa';  
      }      
    } else {      
      return '/gestao-empresa';
    }
  }

  render () {
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
        <div>
          <div className="row internas">
            <Titulo texto="Gerenciar Configurações Bilhete Rodoviária" urlRetorno={this.getRetornoPainel()} />
            {this.state.pagina == 'gestao' && <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
              <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                  <li className="nav-item dropdown nome-empresa">
                    <div className='col-md-6'>
                      <CampoSelecionarEmpresa />
                    </div>
                  </li>
                </ul>
              </div>
            </Autorizacao>}
            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>               
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
               {this.exibirBotaoNovaConfiguracao()}
            </Autorizacao>              
              {this.exibirTabelaEmpresas()}
            <ModalCadastrarConfiguracaoBilhete codigoEmpresaSelecionada={this.state.codigoEmpresaSelecionada}/>
            </div>
          </div>
        </div>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => {
  return {
    configuracaoBilhete: state.configuracaoBilhete.configuracoesBilhete,
    empresaSelecionada: state.empresaSelecionada,
    origem: state.origem,
    changeFieldValue,
    empresas: state.empresas,
  }};


export default connect(mapStateToProps,
  {
    selecionarOrigem,
    buscarRegraCalculoBilhete,
    buscarEmpresa,
    selecionarBilhete,
    buscarConfiguracoesBilhete,
    buscarOpcoesFiltrosConfiguracaoBilhete
  })(reduxForm({
  form: 'formCadastrarConfiguracaoBilhete'
})(PainelConfiguracaoBilhete))
